module.exports = __webpack_public_path__ + "static/media/link-arrow.d7b6873a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/link-arrow.svg
// module id = 142
// module chunks = 0